// extracted by mini-css-extract-plugin
module.exports = {"notFoundWrapper":"styles_notFoundWrapper__F2W55"};